import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from "../../../auth/service";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { FormBuilder } from "@angular/forms";
import { coreConfig } from "../../../app-config";
import { Subscription } from "rxjs";
import {Business} from "../../../../@core/types/data/business";

@Component({
  selector: 'app-business-status',
  templateUrl: './business-status.component.html',
  styleUrls: ['./business-status.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class BusinessStatusComponent {
  businessRegistrationStatus: string = 'CREATED';
  private currentUser: any;
  private currentBusiness: any;

  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private _authenticationService: AuthenticationService,
    private router: Router
  ) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };

  }

  ngOnInit(): void {
    this._authenticationService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
    this._authenticationService.business.subscribe((business) => {
        if (business) {
          this.currentBusiness = business;
        }
      });
    this.businessRegistrationStatus = this.currentBusiness.status;
    console.log(this.businessRegistrationStatus);
  }

  signOut() {
    this._authenticationService.signout();
  }




  ngOnDestroy() {

  }

  protected readonly coreConfig = coreConfig;

  openChat() {

  }
}
